import React from 'react'
import { FlagWrapper, FlagComponent, FlagBody } from '@jsluna/react'
import { InfoCircle } from '@jsluna/icons'
import { PropTypes } from 'prop-types'

const PassStatusCard = props => (
  <div>
    {props.actionText === 'Authorisation' &&
    <div className="ln-u-bg-color-grey-light ln-u-margin-top*2 u-rounded-corners ln-u-padding-right*1/2">
      <div className=" ln-u-padding-sides ln-u-padding-ends*1/2">
        <FlagWrapper>
          <FlagBody className="ln-u-text-align-right u-margin-topMinus1Space">
            <InfoCircle />
          </FlagBody>
          <FlagComponent>
            <div className="ln-u-padding-left">
              {`${props.actionText} required`}
            </div>
          </FlagComponent>
        </FlagWrapper>
      </div>
    </div>}
    {props.actionText === 'Sign off' &&
    <div className="ln-u-bg-color-grey-light ln-u-margin-top*2 u-rounded-corners ln-u-padding-right*1/2">
      <div className=" ln-u-padding-sides ln-u-padding-ends*1/2">
        <FlagWrapper>
          <FlagBody className="ln-u-text-align-right u-margin-topMinus1Space">
            <InfoCircle />
          </FlagBody>
          <FlagComponent>
            <div className="ln-u-padding-left">
              {`${props.actionText} required`}
            </div>
          </FlagComponent>
        </FlagWrapper>
      </div>
    </div>}
  </div>
)

PassStatusCard.propTypes = {
  actionText: PropTypes.string.isRequired
}

export default PassStatusCard



// WEBPACK FOOTER //
// ./src/components/Passes/PassStatusCard/index.jsx